import { Component, signal, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UiToast } from '@shared/components/ui';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, UiToast, LoadingComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.css',
})
export class App implements OnInit {
  protected readonly title = signal('app-ventaclick-frontend-new');
  private readonly document = inject(DOCUMENT);

  ngOnInit(): void {
    if (environment.festiveTheme) {
      this.document.body.classList.add(`theme-${environment.festiveTheme}`);
    }
  }
}
